import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14","key":"svg-0"}],["path",{"d":"M10 10l2 -2v8","key":"svg-1"}]]

const IconSquareNumber1 = createReactComponent('outline', 'square-number-1', 'SquareNumber1', __iconNode);

export default IconSquareNumber1;